import React, {useEffect, useState} from 'react';
import InfoGlobalGraphView from './InfoGlobalGraphView';
import { getTachesGraphGlobal } from '../../../services/MadricService';
import { getUsers } from '../../../services/MadricService';

/**
 *  InfoGlobalBase
 * @return {JSX}
 */
function InfoGlobalGraph() {
  const [tacheInfo, setTacheInfo] = useState([]);
  const [waitTimeFetchInfo, setWaitTimeFetchInfo] = useState(false);
  const [total, setTotal] = useState(0);
  const [periodTime, setPeriodTime] = useState("1")
  const [employers, setEmployers] = useState([])
  const [selectedEmploye, setSelectedEmploye] = useState({label: "Tous les employés", value: 555})

  useEffect(() => {
    getTacheInfo();
    fetchEmployers();
  }, []);

  async function fetchEmployers(){
    const res = await getUsers();
    res.push({label: "Tous les employés", value: 555})
    setEmployers(res);
  }


  function handlePeriodOfTime(event)
  {
    setPeriodTime(event.target.value);
  }

  /**
   * Permet d'allez chercher toutes les informations des tâches
   */
  async function getTacheInfo() {
    const res = await getTachesGraphGlobal(periodTime, selectedEmploye.label);
    setTacheInfo(res.data);
    const arrayOfIntegers = res.data.sums.map((str) => parseInt(str));
    setTotal(arrayOfIntegers.reduce((acc, curr) => acc + curr, 0));
    setWaitTimeFetchInfo(true);
  }

  function handleChangeEmployer(event){
    setSelectedEmploye(event)
  }

  function filtrer(){
    getTacheInfo()
  }

  return (
    <React.Fragment>
      {waitTimeFetchInfo === false ? '' : 
      <InfoGlobalGraphView
        handlePeriodOfTime={handlePeriodOfTime}
        handleChangeEmployer={handleChangeEmployer}
        filtrer={filtrer}
        employers={employers}
        selectedEmploye={selectedEmploye}
        names={tacheInfo.names}
        colors={tacheInfo.colors}
        sums={tacheInfo.sums}
        total={total}
        sumUser={tacheInfo.sumUser}
        users={tacheInfo.users}/>}
    </React.Fragment>
  );
}

export default InfoGlobalGraph;
